<template>
  <div :class="{mask: true}">
    <div
      v-if="showImg"
      class="image mb-5"
    >
      <img :src="img">
    </div>
    <div :class="{name: true}">
      <h4 class="white pb-3">
        {{ name }}
      </h4>
      <p>{{ versionText }}</p>
    </div>
    <div
      class="description"
      :style="[description.length > 20 ? {'min-height' : '5rem'} : {}]"
    >
      <p>{{ description }}</p>
    </div>
    <hr
      class="
      mb-5 mt-3"
    >
    <div class="features mb-5">
      <template v-if="features.length > 0">
        <ul
          v-for="(group, groupIdx) in features"
          :key="groupIdx"
          class="pb-3 px-0 list-disc"
        >
          <span>{{ group.title }}</span>
          <li
            v-for="(item, itemIdx) in group.list"
            :key="itemIdx"
            class="ml-6"
          >
            <template v-if="item !== '<br>'">
              {{ item }}
            </template>
            <template v-else>
              <br class="half-height">
            </template>
          </li>
        </ul>
      </template>
    </div>
    <div
      v-if="saleSection"
      class="sale-section relative py-5"
    >
      <slot />
      <img
        v-if="saleSection.enableIcon"
        class="absolute top-0 left-0"
        src="@/assets/promo-icons/sale-1.png"
      >
    </div>
    <div
      v-if="requirements.length > 0"
      class="requirements text-center"
    >
      <li
        v-for="(item, itemIdx) in requirements"
        :key="itemIdx"
        class="list-none ml-0"
      >
        {{ item }}
      </li>
    </div>
    <hr class="mb-5 mt-3">
    <div class="text-center relative">
      <img
        v-if="showLimitedTimeIcon"
        class="limited-time-icon absolute"
        src="@/assets/promo-icons/sale-2.png"
      >
      <div
        v-if="!isFree"
        class="price"
      >
        <template v-if="!promoPrice">
          <h3>USD ${{ price }}</h3>
        </template>
        <template v-else>
          <h3 class="discount">
            USD ${{ promoPrice }}
            <span>${{ price }}</span>
          </h3>
        </template>
        <h4>
          <span>人民币参考价</span>
          ¥{{ priceRef }}
        </h4>
      </div>
      <!-- <button @click="$router.push('/bias&#45;fx2&#45;coupon')"> -->
      <!--   领取优惠码 -->
      <!-- </button> -->
      <button
        v-if="owned"
        :class="{'invert-button': isFree}"
        disabled
      >
        已经拥有
      </button>
      <button
        v-else-if="tmallLink"
        :id="`order-sku-${sku}`"
        @click="toTmallFun(tmallLink)"
      >
        购买
      </button>
      <button
        v-else-if="isLoginValid"
        :id="`order-sku-${sku}`"
        :class="{'invert-button': isFree}"
        @click="showBuyModal({ sku, price, versionText, img, name })"
      >
        {{ purchaseText }}
      </button>
      <button
        v-else
        :class="{'invert-button': isFree}"
        disabled
      >
        请先登录
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import store from '@/store'

export default {
  components: {},
  props: {
    versionText: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    price: {
      type: Number,
      default: 9999
    },
    priceRef: {
      type: Number,
      default: 9999
    },
    img: {
      type: String,
      default: ''
    },
    sku: {
      type: String,
      default: ''
    },
    features: {
      type: Array,
      default: () => []
    },
    owned: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    showImg: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    requirements: {
      type: Array,
      default: () => []
    },
    promoPrice: {
      type: Number,
      default: 9999
    },
    saleSection: {
      type: Object,
      default: null
    },
    showLimitedTimeIcon: {
      type: Boolean,
      default: false
    },
    // to Tmall goods
    tmallLink: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  store,
  computed: {
    ...mapGetters('Auth', {
      isLoginValid: 'isLoginValid'
    }),
    purchaseText () {
      return this.isFree ? '立即下载' : '购买'
    },
    isFree () {
      return isNaN(this.price)
    }
  },
  methods: {
    ...mapActions('ModalBuy', {
      showBuyModal: 'showBuyModal'
    }),
    backgroundStyle () {
      return `background-image: url(${this.photoUrl});`
    },
    toTmallFun (link) {
      window.open(link)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/base/breakpoint.scss";

.half-height {
  display: block;
  margin-top: .5rem;
  content: '';
}

.mask {
  display: flex;
  flex: 0 0 100%;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  margin: 8px;
  padding: 30px 22px;
  position: relative;
  border-radius: 10px;
  background-color: #131313;
  align-self: stretch;

  @include breakpoint("medium") {
      flex: 0 0 310px;
  }
}

.expansion {
  height: 700px;
  width: 186px;
  @media (max-width: 1000px) {
    width: 320px;
  }
}

.name {
  text-align: left;
}

.name h4 {
  font-size: 18px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #e8e8e8;
  margin: 0;
  word-break: keep-all;
}
.name p {
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  font-size: 15px;
  letter-spacing: normal;
  color: #c3c3c3;
  margin: 0;
}

.description {
  text-align: left;

  p {
    font-size: 15px;
    font-size: 15px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #c3c3c3;
  }
}

.extend-description {
  min-height: 12rem;
  @media (max-width: 1000px) {
    min-height: 6rem;
  }
}
.extend-name {
  min-height: 50px;
}
.extend-name h4 {
  font-size: 16px;
  color: white;
  margin-top: 1rem;
}
.features {
  flex: 1 1 0%;

  span {
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #c1af84;
  }
}

li {
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.93;
  letter-spacing: normal;
  color: #c3c3c3;
}

hr {
  width: 100%;
  border-color: #484848;
  border-width: 1px;
}

button:disabled {
  background-color: grey;
}

.price h3 {
  font-size: 22px;
}
.price h3 span {
  text-decoration: line-through;
  font-weight: 300;
}

.price h4 span {
  font-size: 14px;
  color: grey;
}

.image img {
  width: 100%;
  /* height: 121px; */
  object-fit: contain;
}

.promo {
  color: #fff6d1;
  text-align: center;
}

.promo img {
  height: 63px;
  width: 63px;
  object-fit: contain;
}

.hidePromo {
  opacity: 0;
  pointer-events: none;
  user-select: none;
}

.requirements {

  li {
    color: #8d8d8d;
    @include breakpoint("small") {
      font-size: 12px;
    }
    font-size: 14px;
    text-align: center;
  }
}

.sale-section {
  h4 {
    font-size: 16px;
    color: #c1af84;
  }

  span {
    color: #c1af84;
  }

  p {
    font-size: 14px;
  }
}

.limited-time-icon {
  top: -2rem;
  left: -0.3rem;
}

</style>



// WEBPACK FOOTER //
// src/components/software.vue